<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7" class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            <!-- {{$route.name}} -->
          </h6>
          <!-- <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav> -->
        </b-col>
        <!-- <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col> -->
      </b-row>

      
    </base-header>

    <b-container fluid class="mt--6" style="margin-top:-38px !important">
      <b-row class="justify-content-center">
        <b-col xl="2" md="6">
          <div class="analysis-tab " @click="selectTab(1)" >
          <stats-card title="Futures"
                      type="gradient-red"
                      sub-title="商品期货"
                      icon=""
                      :class="{ 'analysis-tab-active': selectedTab==1 }"
                      >
          </stats-card>
          </div>
        </b-col>
        <b-col xl="2" md="6">
          <div class="analysis-tab " @click="selectTab(2)">
          <stats-card title="Industries"
                      type="gradient-orange"
                      sub-title="A股-行业板块"
                      :class="{ 'analysis-tab-active': selectedTab==2 }"
                      icon="">
          </stats-card>
          </div>
        </b-col>
        <b-col xl="2" md="6">
          <div class="analysis-tab " @click="selectTab(3)">
          <stats-card title="Focus"
                      type="gradient-green"
                      sub-title="A股-热点"
                      :class="{ 'analysis-tab-active': selectedTab==3 }"
                      icon="">
          </stats-card>
          </div>

        </b-col>
        <b-col xl="2" md="6">
          <div class="analysis-tab " @click="selectTab(4)">
          <stats-card title="Areas"
                      type="gradient-info"
                      sub-title="A股-地区板块"
                      :class="{ 'analysis-tab-active': selectedTab==4 }"
                      icon=""
                     >
            
          </stats-card>
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center" v-if="selectedTab==1">
        <b-col lg="8" class="card-wrapper">
          <!-- Grid system -->
          <card class="card">
            <h3 slot="header" class="mb-0">AI自动解读市场，分析行情趋势</h3>
            <p style="margin-top:-5px;margin-bottom:-10px">AI结合即时的全网资讯、K线解读、以及网友的数据投喂等，分析当下行情；欢迎投喂数据，提供线索、思想或建议；
                <br/>多头强势时建议不要做空，空头强势时建议不要做多！
                仅作技术研究，不构成任何投资建议。
            </p>            
          </card>
          <!-- Equal-width -->
          <card  >
            <h2 slot="header" class="mb-0">板块分析</h2>

             <div class="fee-module-body-card">
                <div  v-for="row in futureIndustries">
                  <div class="fee-card fee-card-pc fee-card-small"  >
                    <div  class="fee-card-body">
                        <div v-if="row.long_short==-1" class="fee-card-body-short">空头强势</div>
                        <div v-if="row.long_short==1" class="fee-card-body-long">多头强势</div>
                        <div v-if="row.long_short==0" class="fee-card-body-none">
                          <span v-if="row.last_direction==1">震荡偏多</span>
                          <span v-if="row.last_direction==-1">震荡偏空</span>
                          <span v-if="row.last_direction==0">震荡区间</span>
                        </div>
                        <div >
                        <div  class="fee-card-body-title fee-card-body-title-big">
                          <div >{{ row.name }}</div>
                        </div>
                        </div>
                    </div>
                  </div>
                  </div>
              </div>
          </card>


          <card  v-for="(item, index) in categoies">
            <h2 slot="header" class="mb-0" v-if="category=='' || category==index">{{item}}</h2>

             <div class="fee-module-body-card" v-if="category=='' || category==index">
                <div  v-for="row in futuresLongShort">
                  <div class="fee-card fee-card-pc fee-card-small"  v-if="row.category_name == item">
                    <div  class="fee-card-body">
                        <div v-if="row.long_short==-1" class="fee-card-body-short">空头强势</div>
                        <div v-if="row.long_short==1" class="fee-card-body-long">多头强势</div>
                        <div v-if="row.long_short==0" class="fee-card-body-none">
                          <span v-if="row.last_direction==1">震荡偏多</span>
                          <span v-if="row.last_direction==-1">震荡偏空</span>
                          <span v-if="row.last_direction==0">震荡区间</span>
                        </div>
                        <div >
                        <div  class="fee-card-body-title fee-card-body-title-big">
                          <div >{{ row.name }}</div>
                        </div>
                        </div>
                    </div>
                  </div>
                  </div>
              </div>
          </card>
        
      </b-col>
    </b-row>

    <b-row class="justify-content-center" v-if="selectedTab==2">
        <b-col lg="8" class="card-wrapper">
          <!-- Grid system -->
          <card class="card">
            <h3 slot="header" class="mb-0">AI自动解读市场，分析行业板块</h3>
            <p style="margin-top:-5px;margin-bottom:-10px">AI结合即时的全网资讯、K线解读、以及网友的数据投喂等，分析当下行情；欢迎投喂数据，提供线索、思想或建议；
                <br/>多头强势时建议不要做空，空头强势时建议不要做多！
                仅作技术研究，不构成任何投资建议。
            </p>            
          </card>
          <!-- Equal-width -->
          <card  >
            <h2 slot="header" class="mb-0">A股-行业板块</h2>

             <div class="fee-module-body-card">
                <div  v-for="row in stockCategories">
                  <div class="fee-card fee-card-pc fee-card-small"  >
                    <div  class="fee-card-body">
                        <div v-if="row.long_short==-1" class="fee-card-body-short">空头强势</div>
                        <div v-if="row.long_short==1" class="fee-card-body-long">多头强势</div>
                        <div v-if="row.long_short==0" class="fee-card-body-none">
                          <span v-if="row.last_direction==1">震荡偏多</span>
                          <span v-if="row.last_direction==-1">震荡偏空</span>
                          <span v-if="row.last_direction==0">震荡区间</span>
                        </div>
                        <div >
                        <div  class="fee-card-body-title fee-card-body-title-big">
                          <div >{{ row.name }}</div>
                        </div>
                        </div>
                    </div>
                  </div>
                  </div>
              </div>
          </card>


          <card  v-for="(item, index) in stockCategories">
            <h2 slot="header" class="mb-0" v-if="+item.parent_id==0">{{item.name}}</h2>

             <div class="fee-module-body-card">
                <div  v-for="row in stockCategoriesList">
                  <div class="fee-card fee-card-pc fee-card-small"  v-if="row.parent_id == item.id">
                    <div  class="fee-card-body">
                        <div v-if="row.long_short==-1" class="fee-card-body-short">空头强势</div>
                        <div v-if="row.long_short==1" class="fee-card-body-long">多头强势</div>
                        <div v-if="row.long_short==0" class="fee-card-body-none">
                          <span v-if="row.last_direction==1">震荡偏多</span>
                          <span v-if="row.last_direction==-1">震荡偏空</span>
                          <span v-if="row.last_direction==0">震荡区间</span>
                        </div>
                        <div >
                        <div  class="fee-card-body-title fee-card-body-title-big">
                          <div >{{ row.name }}</div>
                        </div>
                        </div>
                    </div>
                  </div>
                  </div>
              </div>
          </card>
        
      </b-col>
    </b-row>


    <b-row class="justify-content-center" v-if="selectedTab==3">
        <b-col lg="8" class="card-wrapper">
          <!-- Grid system -->
          <card class="card">
            <h3 slot="header" class="mb-0">AI自动解读市场，捕捉当下热点、概念</h3>
            <p style="margin-top:-5px;margin-bottom:-10px">AI结合即时的全网资讯、K线解读、以及网友的数据投喂等，分析当下行情；欢迎投喂数据，提供线索、思想或建议；
                <br/>第一时间捕捉当下热点、概念！
                仅作技术研究，不构成任何投资建议。
            </p>            
          </card>
          <!-- Equal-width -->
          <!-- this.stockConcepts = data.concepts;
            this.stockTags = data.tags; -->
          <card  >
            <h2 slot="header" class="mb-0">A股-热门标签</h2>

             <div class="fee-module-body-card">
                <div  v-for="row in stockTags">
                  <div class="fee-card fee-card-pc fee-card-small"  >
                    <div  class="fee-card-body">
                        <div v-if="row.long_short==-1" class="fee-card-body-short">空头强势</div>
                        <div v-if="row.long_short==1" class="fee-card-body-long">多头强势</div>
                        <div v-if="row.long_short==0" class="fee-card-body-none">
                          <span v-if="row.last_direction==1">震荡偏多</span>
                          <span v-if="row.last_direction==-1">震荡偏空</span>
                          <span v-if="row.last_direction==0">震荡区间</span>
                        </div>
                        <div >
                        <div  class="fee-card-body-title fee-card-body-title-big">
                          <div >{{ row.name }}</div>
                        </div>
                        </div>
                    </div>
                  </div>
                  </div>
              </div>
          </card>

          <card  >
            <h2 slot="header" class="mb-0">A股-热点概念</h2>

             <div class="fee-module-body-card">
                <div  v-for="row in stockConcepts">
                  <div class="fee-card fee-card-pc fee-card-small"  >
                    <div  class="fee-card-body">
                        <div v-if="row.long_short==-1" class="fee-card-body-short">空头强势</div>
                        <div v-if="row.long_short==1" class="fee-card-body-long">多头强势</div>
                        <div v-if="row.long_short==0" class="fee-card-body-none">
                          <span v-if="row.last_direction==1">震荡偏多</span>
                          <span v-if="row.last_direction==-1">震荡偏空</span>
                          <span v-if="row.last_direction==0">震荡区间</span>
                        </div>
                        <div >
                        <div  class="fee-card-body-title fee-card-body-title-big">
                          <div >{{ row.name }}</div>
                        </div>
                        </div>
                    </div>
                  </div>
                  </div>
              </div>
          </card>

          


        
      </b-col>
    </b-row>


     <b-row class="justify-content-center" v-if="selectedTab==4">
        <b-col lg="8" class="card-wrapper">
          <!-- Grid system -->
          <card class="card">
            <h3 slot="header" class="mb-0">AI自动解读市场，分析地区板块行情趋势</h3>
            <p style="margin-top:-5px;margin-bottom:-10px">AI结合即时的全网资讯、K线解读、以及网友的数据投喂等，分析当下行情；欢迎投喂数据，提供线索、思想或建议；
                <br/>多头强势时建议不要做空，空头强势时建议不要做多！
                仅作技术研究，不构成任何投资建议。
            </p>            
          </card>
          <!-- Equal-width -->
          <card  >
            <h2 slot="header" class="mb-0">A股-地区板块</h2>

             <div class="fee-module-body-card">
                <div  v-for="row in stockAreas">
                  <div class="fee-card fee-card-pc fee-card-small"  >
                    <div  class="fee-card-body">
                        <div v-if="row.long_short==-1" class="fee-card-body-short">空头强势</div>
                        <div v-if="row.long_short==1" class="fee-card-body-long">多头强势</div>
                        <div v-if="row.long_short==0" class="fee-card-body-none">
                          <span v-if="row.last_direction==1">震荡偏多</span>
                          <span v-if="row.last_direction==-1">震荡偏空</span>
                          <span v-if="row.last_direction==0">震荡区间</span>
                        </div>
                        <div >
                        <div  class="fee-card-body-title fee-card-body-title-big">
                          <div >{{ row.name }}</div>
                        </div>
                        </div>
                    </div>
                  </div>
                  </div>
              </div>
          </card>


        
      </b-col>
    </b-row>
  </b-container>
  </div>
</template>
<script>
import RouteBreadcrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import BaseHeader from '@/components/BaseHeader';
import futureApi from "../../api/future";
import stockApi from "../../api/stock";
import { Table, TableColumn, Select, Option } from "element-ui";

export default {
    name: 'grid-system',
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        BaseHeader,
        RouteBreadcrumb
    },
    data() {
        return {
            selectedTab:1,
            category:"",
            categoies:{},
            futuresLongShort:[],//期货品种多空
            futureIndustries:[],//期货行业板块
            stockAreas:[],//A股-地区板块
            stockConcepts:[],//A股-热点概念
            stockTags:[],//A股-热点标签
            stockCategories:[],//A股-分类
            stockCategoriesList:[],//A股-分类
        };
    },
    watch: {
        // category: function (val) {
        //     this.getFutureLongShort()
        // },
    },
    methods: {
    
        async selectTab(val)
        {
          this.selectedTab = val;
        },
        async getFutureIndustries()
        {
          const res = await futureApi.getIndustries({});
          if (res && res.code == 200) {
          
            const { data } = res;
            this.futureIndustries = data.industries;
            // console.log("====this.futureIndustries",this.futureIndustries);

          }
        },
        async getFutureLongShort()
        {
            const category = this.category;

            let fromData = {}
            if(category && category != undefined && category != "")
            {
                fromData.category = category;
            }
            const res = await futureApi.getLongShort(fromData);
            if (res && res.code == 200) {

                const { data } = res;
                this.futuresLongShort = data.futures;
                this.categoies = data.categoies;
                
                // console.log("---this.categoies:",this.categoies)
                // console.log("---futuresLongShort:",this.futuresLongShort)
            }
        },
        async getStockCategories()
        {
          const res = await stockApi.getCategories({});
          if (res && res.code == 200) {
          
            const { data } = res;
            this.stockCategories = data.categories;
            this.stockCategoriesList = data.list;
            
            // console.log("====this.stockCategories",this.stockCategories);
            // console.log("====this.stockCategoriesList",this.stockCategoriesList);

          }
        },
        async getStockFocus()
        {
          const res = await stockApi.getFocus({});
          if (res && res.code == 200) {
          
            const { data } = res;
            this.stockConcepts = data.concepts;
            this.stockTags = data.tags;

            // console.log("this.stockConcepts:",this.stockConcepts);
            // console.log("this.stockTags:",this.stockTags);
          }
        },
        async getStockAreas()
        {
          const res = await stockApi.getAreas({});
          if (res && res.code == 200) {
          
            const { data } = res;
            this.stockAreas = data.list;
            // console.log("this.stockAreas:",this.stockAreas);
          }

        },
        async getList()
        {
          this.getFutureLongShort();
          this.getFutureIndustries();
          this.getStockCategories();
          this.getStockFocus();
          this.getStockAreas();
        },
    },
    
    mounted() {
        this.getList();
        this.timer = setInterval(this.getList, 10000);
    },

    destroyed() {
        clearInterval(this.timer);
    },
};
</script>
<style>

.fee-nav-list {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #bfbfbf;
    padding: 5px 50px 0px;
}
.fee-nav-list-item-active {
    border-bottom: 6px solid;
    color: #191b1e;
}

.fee-nav-list-item-active {
    border-bottom: 6px solid;
    color: #191b1e;
}

.fee-nav-list-item {
    height: 48px;
    box-sizing: content-box;
    padding: 0 25px;
    color: #9d9d9d;
    font-weight: 700;
    font-size: 26px;
    cursor: pointer;
}

.fee-module-body-card {
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    flex-wrap: wrap;
    justify-content: flex-start;

}

.fee-card-pc {
    background-color: #eeeeee;
    box-shadow: 0 23px 27px 0 rgba(215,221,229,.2);
    border-radius: 16px 20px 20px 20px;
    padding-top: 26px;
    width: 140px;
    height: 118px;
    box-sizing: border-box;
    margin-bottom: 10px;
    margin-left: 14px;

}



.fee-card-pc .fee-card-body-long {
    color: #ff6900;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 28px;
    line-height: 30px;
}

.fee-card-pc .fee-card-body-short {
    color: #41ce09;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 28px;
    line-height: 30px;
}

.fee-card-pc .fee-card-body-none {
    color: #8d8d8d;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 28px;
    line-height: 30px;
}


.fee-card-pc .fee-card-body-title-big {
    font-size: 22px;
}
.fee-card-pc .fee-card-body-title {
    text-align: center;
    font-weight: 300;
    margin-top: 5px;
}
.analysis-tab
{
  cursor: pointer;
}

.analysis-tab-active
{
  cursor: pointer;
  background: rgb(223 223 223);
}
</style>
